import request from '@/utils/request'

export function findCpeSupplierModels(params) {
  return request({
    url: `/cpe_supplier_models`,
    method: 'get',
    params
  })
}

export function findCpeSupplierModelsBySupplier(supplierId, params) {
  return request({
    url: `/cpe_suppliers/${supplierId}/models`,
    method: 'get',
    params
  })
}

export function findCpeSupplierModelForm(id) {
  return request({
    url: `/cpe_supplier_models/${id}/form`,
    method: 'get'
  })
}

export function findCpeSupplierModelOptions(params) {
  return request({
    url: `/cpe_supplier_models/options`,
    method: 'get',
    params
  })
}

export function createCpeSupplierModel(data) {
  return request({
    url: `/cpe_supplier_models`,
    method: 'post',
    data
  })
}

export function updateCpeSupplierModel(id, data) {
  return request({
    url: `/cpe_supplier_models/${id}`,
    method: 'put',
    data
  })
}
